import { usePopup } from 'hooks/usePopup';

import UpdateAndVerifyPhonePopup from './UpdateAndVerifyPhonePopup';

export const useVerifyPhonePopup = () => {
  const { showPopup, hidePopup } = usePopup();

  const showVerifyPhonePopup = (onConfirmed?: () => void, phoneNumber?: string) =>
    showPopup(
      <UpdateAndVerifyPhonePopup
        mobilePhone={phoneNumber}
        onConfirmed={() => {
          hidePopup();
          onConfirmed?.();
        }}
      />
    );

  return { showVerifyPhonePopup };
};
